import { SortOrder } from 'antd/lib/table/interface';

export const getCustomSortOrderName = (order: SortOrder) => {
  switch (order) {
    case 'ascend':
      return 'asc';

    case 'descend':
      return 'desc';

    default:
      throw new Error('Sort order does not exist');
  }
};
